import React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout"; // @ts-ignore
import joan from "../images/joan-robinson.jpg";
import { Link } from "gatsby";
var AboutPage = function AboutPage(_ref) {
    var data = _ref.data;
    return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SEO, {
        title: data.datoCmsAbout.title
    }), /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full border-t-8 border-solid border-makroOrange lg:w-2/3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Das Magazin f\xFCr Wirtschaftspolitik"), /*#__PURE__*/ React.createElement("div", {
        className: "px-3 lg:pl-8 lg:pr-12"
    }, /*#__PURE__*/ React.createElement("h1", {
        className: "text-makroOrange text-3xl md:text-5xl"
    }, data.title), /*#__PURE__*/ React.createElement("div", {
        className: "mt-6 mb-4 relative"
    }, /*#__PURE__*/ React.createElement("img", {
        src: joan,
        alt: "Joan Robinson"
    }), /*#__PURE__*/ React.createElement("small", {
        className: "absolute text-white text-lg",
        style: {
            bottom: "3px",
            right: "5px"
        }
    }, "Joan Robinson")), /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "content-text pb-8 md:pr-48",
        dangerouslySetInnerHTML: {
            __html: data.datoCmsAbout.content
        }
    }), /*#__PURE__*/ React.createElement("div", {
        className: "mb-8 p-4 content-text about-box bg-makroOrangeLight border-t-8 border-solid border-makroOrange lg:absolute",
        style: {
            fontSize: "16px"
        }
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "text-makroOrange text-xl",
        style: {
            marginTop: "0"
        }
    }, "MAKROSKOP. Das Magazin f\xFCr Wirtschaftspolitik"), /*#__PURE__*/ React.createElement("ul", null, /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Bei MAKROSKOP erfahren Sie, warum die Staatsverschuldung per se ungef\xE4hrlich und ein Gebot f\xFCr die Bew\xE4ltigung vieler Zukunftsfragen ist."), /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Wir suchen nach einer globalen Ordnung, die aus den Fehlern einer ungehemmten Entgrenzung gelernt und auch die Belange derjenigen im Auge hat, die bisher die Verlierer der radikalen Globalisierung waren."), /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Wir setzen uns kritisch mit der EU und dem EURO auseinander. Wir legen den Finger in die Wunde, die entsteht, wenn die gegenw\xE4rtige institutionelle Ausgestaltung der EU in eine Richtung weiterentwickelt wird, die Demokratie und sozialen Zusammenhalt gef\xE4hrdet."), /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Wir erkl\xE4ren, warum die umlagefinanzierte gesetzliche Rente kein Auslaufmodell ist. Kapitalgedeckte Alternativen sind ein gef\xE4hrlicher Irrweg, die zur Destabilisierung der Finanzm\xE4rkte beitragen k\xF6nnen."), /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Sie erfahren bei MAKROSKOP, dass das exportgetriebene Wachstumsmodell Deutschlands keine Zukunft hat. Umunsere Wirtschaft zu stabilisieren, bedarf es deswegen guter L\xF6hne und eines funktionierenden Wohlfahrtstaates."), /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Welchen Zusammenhang zwischen der Gestaltung des nationalen Arbeitsmarktes und der Produktivit\xE4tsentwicklung einer Gesellschaft gibt es? Gute Argumente sprechen daf\xFCr, dass ein flexibler Arbeitsmarkt die Produktivit\xE4tsentwicklung hemmt, w\xE4hrend starre Arbeitssysteme die Unternehmen zu Investitionen und somit zu Produktivit\xE4tssteigerungen zwingen."), /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Wir machen uns auf die Suche nach der besten \xF6konomischen Basis f\xFCr die Gleichberechtigung der Geschlechter."), /*#__PURE__*/ React.createElement("li", {
        className: "mb-2"
    }, "Wie kann der Weg in eine \xF6kologische Zukunft am besten gestaltet werden? Ist es der viel gepriesene Preismechanismus (Stichwort \u201EVerschmutzungszertifikate\u201C) oder bedarf es staatlicher Interventionen und Vorgaben?")), /*#__PURE__*/ React.createElement("p", {
        className: "h0 normal-line-height text-2xl text-makroOrange",
        style: {
            marginTop: "20px"
        }
    }, "Unterst\xFCtzen Sie uns"), /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(Link, {
        to: "/abonnieren/",
        className: "font-bold text-black-important hover:text-makroOrange-important"
    }, "Zeichnen Sie ein Abonnement"), " und profitieren Sie von w\xF6chentlichen wirtschaftspolitischen Analysen und Kommentaren."))))))));
};
var query = "3239350207";
export default AboutPage;
